import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const prodConfig = {
  apiKey: "AIzaSyBDW64t-Az0UI2VhszCZdpMSZIEZRmzBo4",
      authDomain: "hactivate-v1.firebaseapp.com",
      databaseURL: "https://hactivate-v1.firebaseio.com",
      projectId: "hactivate-v1",
      storageBucket: "hactivate-v1.appspot.com",
      messagingSenderId: "1042049261399"
    };

const devConfig = {
  apiKey: "AIzaSyBDW64t-Az0UI2VhszCZdpMSZIEZRmzBo4",
      authDomain: "hactivate-v1.firebaseapp.com",
      databaseURL: "https://hactivate-v1.firebaseio.com",
      projectId: "hactivate-v1",
      storageBucket: "hactivate-v1.appspot.com",
      messagingSenderId: "1042049261399"
    };

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js